import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'lmw-common-secondary-page-cta-panel',
  templateUrl: './secondary-page-cta-panel.component.html',
})
export class SecondaryPageCtaPanelComponent implements OnInit {

  constructor() { }

  @Input() public headingText: string;
  @Input() public paragraphText1: string;
  @Input() public paragraphText2?: string;
  @Input() public firstLink: string;
  @Input() public secondLink?: string;
  @Input() public firstLinkText: string;
  @Input() public secondLinkText?: string;

  ngOnInit(): void {
  }

}
